import { render, staticRenderFns } from "./Sorting.vue?vue&type=template&id=c3da69cc&scoped=true&"
import script from "./Sorting.vue?vue&type=script&lang=ts&"
export * from "./Sorting.vue?vue&type=script&lang=ts&"
import style0 from "./Sorting.vue?vue&type=style&index=0&id=c3da69cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3da69cc",
  null
  
)

export default component.exports